import IconOutlink from '@apollo/icons/default/IconOutlink.svg';
import React from 'react';

import { ClickableText } from 'src/components/common/clickableText/ClickableText';
import { Maybe } from 'src/lib/graphqlTypes/types';
import { DocsRouter } from 'src/lib/routers';

type QueryPlanTooltipProps = {
  compositionVersion?: Maybe<String>;
};

export const QueryPlanTooltip = (props: QueryPlanTooltipProps) => {
  const { compositionVersion } = props;

  return (
    <>
      <p>
        A query plan is a blueprint for dividing a single incoming operation
        into one or more operations that are each resolvable by a single
        subgraph.
      </p>
      <p className="pt-2">
        Query plans are generated using your variant's active federation
        version. Note that this may not match the query planning version used at
        runtime.
      </p>
      {compositionVersion && (
        <dl className="flex pt-2">
          <dt>Active Federation Version:</dt>
          <dd className="ml-1 text-blilet-lighter">v{compositionVersion}</dd>
        </dl>
      )}
      <p className="pt-2">
        <ClickableText
          className="font-semibold"
          as="a"
          href={DocsRouter.path('FederationQueryPlans')}
          rel="noopener noreferrer"
          target="_blank"
        >
          Learn more about query plans <IconOutlink className="ml-1" />
        </ClickableText>
      </p>
    </>
  );
};
